import { render } from "./GibergOlora.vue?vue&type=template&id=ab5c0ee6&scoped=true"
import script from "./GibergOlora.vue?vue&type=script&lang=js"
export * from "./GibergOlora.vue?vue&type=script&lang=js"

import "./GibergOlora.vue?vue&type=style&index=0&id=ab5c0ee6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5c0ee6"]])

export default __exports__